import Api from 'core/api';
import useMutation from 'hooks/useMutation';

const useCompleteFeatureOnboarding = () =>
  useMutation({
    apiFunc: ({ pk }) =>
      Api.common.completeFeatureOnboarding({ payload: { pk } }),
    invalidateQueries: ['common.getFeatureOnboardingList'],
  });

export default useCompleteFeatureOnboarding;
